export default {
  'profilecredit.profilecreditreport': 'گردش حساب اعتباری',
  'profilecredit.creditstatus': 'وضعیت اعتبار',
  'profilecredit.credittotalamount': 'میزان کل اعتبار فعال',
  'profilecredit.creditremainamount': 'میزان کل اعتبار باقیمانده',
  'profilecredit.profilecreditreport': 'گزارش اعتبارات تخصیص یافته',
  'profilecredit.creditamount': 'میزان اعتبار',
  'profilecredit.remaincreditamount': 'میزان اعتبار باقیمانده',
  'profilecredit.assigndate': 'تاریخ تخصیص',
  'profilecredit.duration': 'مدت زمان اعتبار(روز)',
  'profilecredit.active': 'فعال',
  'profilecredit.expired': 'منقضی',
  'profilecredit.sum': 'مجموع',
  'profilecredit.expensesamount': 'میزان اعتبار خرج شده',
  'profilecredit.nocredit': 'بدون اعتبار',
  'profilecredit.assigncredit': 'تخصیص اعتبار',
  'profilecredit.creditamountceiling': 'سقف میزان اعتبار',
  'profilecredit.deletecredit': 'حذف اعتبار',
  'profilecredit.deleteconfirmation':
    'آیا از حذف اعتبار تخصیص یافته مطمئن هستید ؟',
  'profilecredit.fullname': 'نام و نام خانوادگی',
  'profilecredit.expensesreport': 'گزارش مصرف',
  'profilecredit.credit': 'اعتبار',
  'profilecredit.mycreditmanagement': 'مدیریت اعتبارات تخصیص یافته به من',
  'profilecredit.creditmanagement': 'مدیریت اعتبارات تخصیص یافته',
  'profilecredit.employeecreditmanagement':
    'مدیریت اعتبارات تخصیص یافته به کارمند',
  'profilecredit.creditadd': 'اعتبار با موفقیت تخصیص یافت',
  'profilecredit.creditadderror':
    'یک اعتبار فعال وجود دارد. امکان ثبت اعتبار جدید وجود ندارد',
  'profilecredit.noteligibleprofile':
    'امکان تخصیص اعتبار برای این پروفایل وجود ندارد',
  'profilecredit.downloadexcel': 'دانلود اکسل گزارش',
  'profilecredit.fromdate': 'تاریخ تخصیص از',
  'profilecredit.todate': 'تاریخ تخصیص تا',
};
